export * from './stratalot-price-generated.actions';

import { createAction, props } from '@ngrx/store';

export const generatePriceValues = createAction(
  '[StratalotPrice] Generate price values for a given price Grid',
  props<{ params: any }>()
);
